$(function() {

	if (tabsWrappperDetect()) tabsWrapperInit();


	// Переключение вкладок кликом по стрелкам
	$('[class*="tabs-nav-arrow-"]').on('click', function(event) {
		var tabsWrapper = $(this).parents('.tabs-wrapper'),
			tabsContentContainer = tabsWrapper.find('.tabs-content-container'),

			tabsAmount = tabsContentContainer.find('.tab-content').length,
			currentActiveTabIndex = tabsContentContainer.find('.tab-content').index(tabsContentContainer.find('.tab-content.active')),
			newActiveTabIndex = 0;

		if ($(this).hasClass('tabs-nav-arrow-next')) newActiveTabIndex = (currentActiveTabIndex < tabsAmount - 1) ? currentActiveTabIndex + 1 : 0;
		else if ($(this).hasClass('tabs-nav-arrow-prev')) newActiveTabIndex = (currentActiveTabIndex > 0) ? currentActiveTabIndex - 1 : tabsAmount - 1;

		showTab(newActiveTabIndex, tabsWrapper);
	});


	// Переключением вкладок кликом по названию вкладки
	$('.tab').on('click', function(event) {
		var tabsWrapper = $(this).parents('.tabs-wrapper'),
			tabsContainer = tabsWrapper.find('.tabs-container'),
			newActiveTabIndex = tabsContainer.find('.tab').index($(this));
		showTab(newActiveTabIndex, tabsWrapper);
	});


	// Переключение вкладок кликом по Двоичному переключателю вкладок
	$('.tabs-switcher').on('click', function(event) {
		var tabsWrapper = $(this).parents('.tabs-wrapper'),
			tabsContentContainer = tabsWrapper.find('.tabs-content-container'),
			currentActiveTabIndex = tabsContentContainer.find('.tab-content').index(tabsContentContainer.find('.tab-content.active')),
			newActiveTabIndex = currentActiveTabIndex == 0 ? 1 : 0;

		showTab(newActiveTabIndex, tabsWrapper);
	});

});


// Проверка на существование блоков со вкладками на странице
function tabsWrappperDetect() {
	return $('.tabs-wrapper').length > 0 ? true : false;
}


// Инициализация блоков со вкладками
function tabsWrapperInit() {
	$('.tabs-wrapper').each(function() {
		var tabsContainer = $(this).find('.tabs-container'),
			tabsContentContainer = $(this).find('.tabs-content-container'),
			tabsNav = $(this).find('.tabs-nav-container'),
			tabsNavArrows = $(this).find('.tabs-nav-arrows-container'),
			tabsNavArrowsCaption = tabsNavArrows.find('.tabs-nav-arrows-caption'),
			tabsSwitcher = $(this).find('.tabs-switcher'),

			tabsAmount = tabsContentContainer.find('.tab-content').length;

		if (tabsAmount > 0) {
			tabsContentContainer.find('.tab-content').eq(0).addClass('active');

			if (tabsContainer.length > 0) {
				tabsContainer.addClass('active');
				tabsContainer.find('.tab').eq(0).addClass('active');
			}
		}

		if (tabsAmount > 1) {
			if (tabsNav.length > 0) {
				tabsNav.addClass('active');
				tabsNav.find('.tabs-nav-item').eq(0).addClass('active');
			}
			if (tabsNavArrows.length > 0) {
				tabsNavArrows.addClass('active');
				tabsNavArrowsCaption.find('span:nth-child(1)').html('1');
				tabsNavArrowsCaption.find('span:nth-child(2)').html(tabsAmount);
			}
			if (tabsSwitcher.length > 0) {
				tabsSwitcher.addClass('active');
				tabsSwitcher.find('span').eq(0).addClass('active');
			}
		}

	});
}


// Показывает вкладку с номеров tabIndex (счет начинается с 0) внутри выбранного блока с вкладками jqTabWrapper (объект jquery)
function showTab(tabIndex, jqTabsWrapper) {
	var tabsWrapper = jqTabsWrapper,
		tabsContainer = tabsWrapper.find('.tabs-container'),
		tabsContentContainer = tabsWrapper.find('.tabs-content-container'),
		tabsNav = tabsWrapper.find('.tabs-nav-container'),
		tabsNavArrows = tabsWrapper.find('.tabs-nav-arrows-container'),
		tabsNavArrowsCaption = tabsNavArrows.find('.tabs-nav-arrows-caption')
		tabsSwitcher = tabsWrapper.find('.tabs-switcher'),

		tabsAmount = tabsContentContainer.find('.tab-content').length,
		currentActiveTabIndex = tabsContentContainer.find('.tab-content').index(tabsContentContainer.find('.tab-content.active')),
		newActiveTabIndex = tabIndex;

	if (currentActiveTabIndex != newActiveTabIndex) {
		tabsContentContainer.find('.tab-content').eq(currentActiveTabIndex).removeClass('active');
		tabsContentContainer.find('.tab-content').eq(newActiveTabIndex).addClass('active');

		tabsContainer.find('.tab').eq(currentActiveTabIndex).removeClass('active');
		tabsContainer.find('.tab').eq(newActiveTabIndex).addClass('active');

		tabsNav.find('.tabs-nav-item').eq(currentActiveTabIndex).removeClass('active');
		tabsNav.find('.tabs-nav-item').eq(newActiveTabIndex).addClass('active');

		tabsNavArrowsCaption.find('span:nth-child(1)').html(newActiveTabIndex + 1);

		tabsSwitcher.find('span').eq(currentActiveTabIndex).removeClass('active');
		tabsSwitcher.find('span').eq(newActiveTabIndex).addClass('active');
	}
}